import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TextInput, Button } from "../..";
import { constructFtpUrl } from "../utils";

interface FTPForm {
  ftp_url: string;
  username: string;
  password: string;
}

interface IFTPAddForm {
  getEncodedUrl: (url: string) => void;
}

export const FTPAddForm = ({ getEncodedUrl }: IFTPAddForm) => {
  const formik = useFormik<FTPForm>({
    initialValues: {
      ftp_url: "",
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      ftp_url: Yup.string().required("Required"),
      username: Yup.string().required("Required"),
      password: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      const ftpUrl = constructFtpUrl(
        values.ftp_url,
        values.username,
        values.password
      );
      getEncodedUrl(ftpUrl || "");
    },
  });

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();

    Object.keys(formik.initialValues).forEach((field) => {
      formik.setFieldTouched(field as keyof typeof formik.initialValues, true);
    });

    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      return;
    }
    formik.submitForm();
  };

  return (
    <div className="bg-light my-2 p-3 rounded position-relative">
      <h6 className="text-uppercase">FTP Upload</h6>
      <div className="row mt-1">
        <div className="col-12 mb-3">
          <TextInput
            onBlur={formik.handleBlur}
            name="ftp_url"
            placeholder="http://"
            onChange={formik.handleChange}
            value={formik.values.ftp_url}
            label="Enter URL:"
            showRequired={true}
            touched={formik.touched.ftp_url}
            error={formik.errors.ftp_url}
            // className="d-flex flex-direction-row mb-3"
          />
        </div>
        <div className="col-5">
          <TextInput
            onBlur={formik.handleBlur}
            name="username"
            placeholder="Enter here..."
            onChange={formik.handleChange}
            value={formik.values.username}
            label="Username :"
            showRequired={true}
            error={formik.errors.username}
            touched={formik.touched.username}
            // className="d-flex flex-direction-row"
          />
        </div>
        <div className="col-5">
          <TextInput
            onBlur={formik.handleBlur}
            name="password"
            placeholder="*****"
            onChange={formik.handleChange}
            value={formik.values.password}
            label="Password :"
            showRequired={true}
            error={formik.errors.password}
            touched={formik.touched.password}
            // className="d-flex flex-direction-row"
          />
        </div>
        <div className="col-2 mt-4">
          <Button
            HTMLButtonType="button"
            // className="btn btn-outline-primary"
            type="outline-primary"
            onClick={handleSave}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );
};
